import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { SuperAdminService } from "src/app/super-admin.service";
import { environment } from "src/environments/environment";
import { ImagePreviewComponent } from "../image-preview/image-preview.component";
import { DomSanitizer } from "@angular/platform-browser";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { viewImages } from "src/assets/js/gallery-viewer";
import { EditLrComponent } from "src/app/superAdmin/LR-management/edit-lr/edit-lr.component";

@Component({
  selector: "app-edit-invoice",
  templateUrl: "./edit-invoice.component.html",
  styleUrls: ["./edit-invoice.component.css"],
})
export class EditInvoiceComponent implements OnInit {
  filesToUpload: Array<File> = [];
  apiUrl = environment.domain;
  isRoleSuperVisor = true;
  userSessionData;
  userroleid;
  acc: any;
  trackerId: string;
  previewURL: any;
  fileDeleted = false;

  @ViewChild("showPreview") showPreview: ElementRef;

  editInvoiceForm = new FormGroup({
    InvoiceNo: new FormControl("", [Validators.required]),
    InvoiceValue: new FormControl("", [Validators.required]),
    NoofArticle: new FormControl("", Validators.required),
    Weight: new FormControl(
      "",
      Validators.compose([
        Validators.required,
        Validators.pattern(/^\d+[.]{1}\d+$|^\d+$/),
      ])
    ),
    customerName: new FormControl("", [Validators.required]),
    POD: new FormControl(""),
  });

  constructor(
    private toastr: ToastrService,
    private superAdminService: SuperAdminService,
    public dialogRef: MatDialogRef<EditLrComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.trackerId = this.data?.trackerId;
    this.userSessionData = JSON.parse(sessionStorage.getItem("userSession"));
    this.userroleid = this.userSessionData.user_role_id[0];
    if (this.userroleid === 2) this.isRoleSuperVisor = false;

    this.acc = this.data?.acc || this.data?.invoice;

    if (this.acc) {
      this.editInvoiceForm.patchValue({
        InvoiceNo: this.acc.InvoiceNo || "",
        InvoiceValue: this.acc.InvoiceValue || "",
        NoofArticle: this.acc.NoofArticle || "",
        Weight: this.acc.Weight || "",
        customerName: this.acc.customerName || "",
      });

      if (this.acc.path) {
        this.previewURL = this.acc.path.includes("http")
          ? this.acc.path
          : `${this.apiUrl}/${this.acc.path}`;
      }
    }
  }

  get ff() {
    return this.editInvoiceForm.controls;
  }

  fileChangeEventAttachment(fileInput: any) {
    this.filesToUpload = [];
    if (fileInput.target.files.length > 0) {
      this.filesToUpload.push(fileInput.target.files[0]);
      this.fileDeleted = false;
    }
  }

  updateInvoice() {
    this.editInvoiceForm.markAllAsTouched();
    if (!this.editInvoiceForm.valid) {
      this.markInvalidFields();
      return;
    }

    this.removevalidatorcss("InvoiceNoctrl");
    this.removevalidatorcss("InvoiceValuectrl");
    this.removevalidatorcss("NoofArticlectrl");
    this.removevalidatorcss("Weightctrl");
    this.removevalidatorcss("customerNamectrl");
    this.removevalidatorcss("PODctrl");

    const acc = this.data?.acc || this.data?.invoice;

    let pathToSend = "";
    const rawPath = acc?.path;

    if (this.fileDeleted) {
      pathToSend = "";
    } else if (this.filesToUpload.length > 0) {
      pathToSend = "";
    } else if (rawPath) {
      const isRemoteUrl = rawPath.startsWith("http") || rawPath.startsWith("/");
      pathToSend = isRemoteUrl ? rawPath : "";
    }

    const form = {
      _id: this.data?.id,
      vId: acc?.id,
      InvoiceNo: this.editInvoiceForm.get("InvoiceNo").value,
      InvoiceValue: this.editInvoiceForm.get("InvoiceValue").value,
      NoofArticle: this.editInvoiceForm.get("NoofArticle").value,
      Weight: this.editInvoiceForm.get("Weight").value,
      customerName: this.editInvoiceForm.get("customerName").value,
      path: pathToSend,
    };

    const formData = new FormData();
    for (let i = 0; i < this.filesToUpload.length; i++) {
      formData.append("uploads[]", this.filesToUpload[i]);
    }
    formData.append("myFormData", JSON.stringify(form));

    this.superAdminService.updateInvoice(formData).subscribe(
      (res: any) => {
        if (res.status === true) {
          this.toastr.success(res.message);
          this.data.getLrDetail();
          this.dialogRef.close();
        } else {
          this.toastr.error(res.message);
        }
      },
      (error) => {
        console.error(error);
        this.toastr.error("Error updating invoice");
      }
    );
  }

  markInvalidFields() {
    const fields = [
      "InvoiceNo",
      "InvoiceValue",
      "NoofArticle",
      "Weight",
      "customerName",
      "POD",
    ];
    for (const f of fields) {
      const ctrl = this.editInvoiceForm.get(f);
      if (ctrl?.invalid) this.addvalidatorcss(f + "ctrl");
      else this.removevalidatorcss(f + "ctrl");
    }
  }

  preview() {
    let file = this.filesToUpload[0];
    if (file) {
      if (
        ["image/jpeg", "image/png", "image/svg", "image/svg+xml"].includes(
          file.type
        )
      ) {
        this.dialog.open(ImagePreviewComponent, {
          width: "80%",
          height: "90vh",
          data: { file: file },
        });
      } else {
        const url = URL.createObjectURL(file);
        window.open(url, "_blank");
      }
    } else {
      let url = this.acc?.path;
      if (url) {
        const fileExtension = url.split(".").pop()?.toLowerCase();
        if (["jpeg", "png", "jpg", "svg"].includes(fileExtension)) {
          this.dialog.open(ImagePreviewComponent, {
            width: "80%",
            height: "90vh",
            data: { file: url },
          });
        } else {
          const fullUrl = url.includes("http") ? url : `${this.apiUrl}/${url}`;
          window.open(fullUrl, "_blank");
        }
      } else {
        this.toastr.error("No attachment available");
      }
    }
  }

  addvalidatorcss(id: string) {
    const el = document.getElementById(id);
    if (el) el.classList.add("validatorcss");
  }

  removevalidatorcss(id: string) {
    const el = document.getElementById(id);
    if (el) el.classList.remove("validatorcss");
  }

  isPdf(filePath: string): boolean {
    if (!filePath) return false;
    const ext = filePath.split(".").pop()?.toLowerCase();
    return ext === "pdf";
  }

  editFile() {
    // Trigger file input programmatically to replace existing file
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*,.pdf";
    input.onchange = (e: any) => {
      const file = e.target.files[0];
      if (file) {
        this.filesToUpload = [file];
        this.editInvoiceForm.get("POD")?.setValue(file.name);
        this.acc.path = null;
        this.fileDeleted = false;

        const reader = new FileReader();
        reader.onload = () => {
          this.previewURL = reader.result;
        };
        reader.readAsDataURL(file);

        this.toastr.info("New file selected. Click Update to save changes.");
      }
    };
    input.click();
  }

  deleteFile() {
    if (confirm("Are you sure you want to delete this attachment?")) {
      this.acc.path = null;
      this.previewURL = null;
      this.filesToUpload = [];
      this.fileDeleted = true;
      this.editInvoiceForm.get("POD")?.reset();

      this.toastr.info(
        "File marked for deletion. Click Update to save changes."
      );
    }
  }

  viewImages(path: string, title: string) {
    if (!path) return;

    const fileExtension = path.split(".").pop()?.toLowerCase();
    if (["jpeg", "jpg", "png", "gif", "svg", "webp"].includes(fileExtension)) {
      viewImages(path, title);
    } else if (fileExtension === "pdf") {
      window.open(path, "_blank");
    } else {
      this.toastr.error("Unsupported file format.");
    }
  }
}
